import { Link } from 'react-router-dom';

export default function PaintingCard({ infos, index }) {
    return (
        <Link to={`/painting/${index}`} className="group block cursor-pointer">
            <div className="space-y-2">
                <div className="relative flex items-center h-72 justify-center transition-all duration-500 group-hover:scale-105">
                    <img
                        className="max-h-full max-w-full object-contain rounded-sm"
                        style={{
                            boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)'
                        }}
                        src={"./images/" + infos.img}
                        alt={infos.name}
                    />
                </div>

                <div className="mx-auto w-fit">
                    <div 
                        className="px-6 py-3 border-2 border-amber-700/30 rounded-sm shadow-md"
                        style={{
                            background: 'linear-gradient(145deg, #c9a227 0%, #d4af37 30%, #f0d060 50%, #d4af37 70%, #c9a227 100%)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -1px 0 rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <h3 className="text-center text-sm font-bold text-amber-950 tracking-wide uppercase">
                            {infos.name}
                        </h3>
                        <div className="flex items-center justify-center gap-3 mt-1 text-xs text-amber-900">
                            <span>{infos.type}</span>
                            <span className="w-1 h-1 rounded-full bg-amber-800"></span>
                            <span>{infos.year}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}

